var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.name !== 'login' )?_c('div',[_c('Sidebar'),(_vm.$route.name == 'home')?_c('div'):_vm._e(),_c('div',{staticClass:"app-content",class:{ 'profile': _vm.$route.name == 'home' }},[_c('Header'),_c('router-view'),_c('Footer')],1)],1):_c('div',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }